import { useTheme } from '@/shared/context'
import { ConfigProvider } from 'antd'
import viVN from 'antd/locale/vi_VN'
import { useEffect } from 'react'
import themeConfigAntd from './ThemeConfigAntd'
import { THEME_CONFIG } from './design-tokens'

function GlobalThemeConfig({ ...rest }) {
  const { theme, themeColor } = useTheme()

  useEffect(() => {
    const tokens = THEME_CONFIG[themeColor]
    const root = document.documentElement

    // Inject CSS Variables for Tailwind/SCSS compliance
    root.style.setProperty('--color-primary', tokens.colorPrimary)
    root.style.setProperty('--color-info', tokens.colorInfo)

    // Optional: Add component specific vars if needed by Tailwind
    // root.style.setProperty('--color-primary-hover', tokens.components.Button.colorPrimaryHover)
  }, [themeColor])

  return (
    <ConfigProvider theme={themeConfigAntd(theme, themeColor)} locale={viVN}>
      {rest.children}
    </ConfigProvider>
  )
}

export default GlobalThemeConfig
